import { connect } from 'react-redux'
import CheckboxListView from '../../../../features/commons/Menu/SearchMenu/checkboxDropdown'
import { addFilter, onChangeCheckbox } from '../../../../actions/searchBar'
import { changeCheckValue } from '../../../../actions/residential';

const mapStateToProps = (state, ownProps) => {
  return {
  	
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
 		addFilter: (value, n) => dispatch(addFilter(value, n)),
 		changeCheckStatus: () => dispatch(changeCheckValue(value)),
 		onChangeCheckbox: (item, value) => dispatch(onChangeCheckbox(item, value))
  }
}

const MenuItem = connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckboxListView)

export default MenuItem


// WEBPACK FOOTER //
// ./src/containers/Sections/Menu/SearchMenu/checkboxList.js